import useAuthUtils from "./useAuthUtils";
import { useCallback, useEffect } from "react";
import { useCookies } from "react-cookie";
import { jwtDecode } from "jwt-decode";
import { useApolloClient } from "@apollo/client";

export const useAuth = () => {
  const auth = useAuthUtils();
  const [cookie, setCookies, removeCookies] = useCookies(["authToken"]);
  const apolloClient = useApolloClient();

  useEffect(() => {
    if (auth.loginResponse && auth.loginResponse.login.jwt) {
      const decodedToken = jwtDecode(auth.loginResponse.login.jwt);

      setCookies("authToken", auth.loginResponse.login.jwt, {
        path: "/",
        expires: new Date(decodedToken?.exp! * 1000),
      });
    }
    if (auth.registerResponse && auth.registerResponse.register.jwt) {
      const decodedToken = jwtDecode(auth.registerResponse.register.jwt);

      setCookies("authToken", auth.registerResponse.register.jwt, {
        path: "/",
        expires: new Date(decodedToken?.exp! * 1000),
      });
    }
    if (
      auth?.resetPasswordResponse &&
      auth?.resetPasswordResponse?.resetPassword?.jwt
    ) {
      const decodedToken = jwtDecode(
        auth.resetPasswordResponse.resetPassword.jwt
      );

      setCookies("authToken", auth.resetPasswordResponse.resetPassword.jwt, {
        path: "/",
        expires: new Date(decodedToken?.exp! * 1000),
      });
    }
    if (
      auth?.confirmEmailResponse &&
      auth?.confirmEmailResponse?.emailConfirmation?.jwt
    ) {
      const decodedToken = jwtDecode(
        auth.confirmEmailResponse.emailConfirmation.jwt
      );

      setCookies("authToken", auth.confirmEmailResponse.emailConfirmation.jwt, {
        path: "/",
        expires: new Date(decodedToken?.exp! * 1000),
      });
    }
  }, [
    auth.loginResponse,
    auth.registerResponse,
    auth.resetPasswordResponse,
    auth.confirmEmailResponse,
    setCookies,
  ]);

  const signOut = useCallback(() => {
    removeCookies("authToken", { path: "/" });
    // proactively clear Apollo caches to avoid stale user data
    apolloClient.clearStore().catch(() => {
      // ignore cache clear errors
    });
  }, [apolloClient, removeCookies]);

  return {
    ...auth,
    token: cookie.authToken,
    signOut,
  };
};
